import { api, prefix } from "@/api";
import type {
  TranslationLabel,
  TranslationLanguage,
  UpdateTranslationPayload,
} from "@/types/translations";
import type { AxiosRequestConfig } from "axios";

const namespace = "platform/translation";

/** Localized messages for Vue I18n: nested object or flat Record<key, value> (dot-notation keys) */
export async function getLocalizedTranslations(
  lang: string,
  config: AxiosRequestConfig = {}
): Promise<Record<string, unknown>> {
  return api<Record<string, unknown>>({
    url: `${prefix}/${namespace}/localized`,
    method: "get",
    headers: {
      "DG-language": lang,
    },
    ...config,
  });
}

export async function getLanguages(
  config: AxiosRequestConfig = {}
): Promise<TranslationLanguage[]> {
  return api<TranslationLanguage[]>({
    url: `${prefix}/${namespace}/languages`,
    method: "get",
    ...config,
  });
}

export async function getTranslations(
  config: AxiosRequestConfig = {}
): Promise<TranslationLabel[]> {
  return api<TranslationLabel[]>({
    url: `${prefix}/${namespace}`,
    method: "get",
    ...config,
  });
}

export const updateTranslation = (
  id: string | number,
  params: UpdateTranslationPayload,
  config: AxiosRequestConfig = {}
) => {
  return api<void>({
    url: `${prefix}/${namespace}/${id}`,
    method: "PUT",
    data: params,
    ...config,
  });
};

export const createTranslation = (params: object, config: AxiosRequestConfig = {}) => {
  return api<{
    createdAt: string;
    createdBy: string;
    deleted: boolean;
    id: number;
    locale: string;
    modifiedAt: null | string;
    modifiedBy: null | string;
    tag: string;
    value: string;
  }>({
    url: `${prefix}/${namespace}`,
    method: "POST",
    data: params,
    ...config,
  });
};

export const deleteTranslation = (id: string | number, config: AxiosRequestConfig = {}) => {
  return api<void>({
    url: `${prefix}/${namespace}/${id}`,
    method: "DELETE",
    ...config,
  });
};
